import { createContext, useContext } from "react";

export interface ConfirmOptions {
  /** The question, in plain words. */
  title: string;
  /** What will happen, when the title alone doesn't say. */
  body?: string;
  /** The confirming button's words; "Confirm" by default. */
  confirmLabel?: string;
  /** Red, for actions that remove or stop something. */
  destructive?: boolean;
}

export type Ask = (options: ConfirmOptions | string) => Promise<boolean>;

export const ConfirmContext = createContext<Ask | null>(null);

/** Asks for confirmation; resolves true when the person confirms. */
export function useConfirm(): Ask {
  const ask = useContext(ConfirmContext);
  if (ask === null) {
    throw new Error("useConfirm needs a ConfirmProvider");
  }
  return ask;
}
